module.exports = __webpack_public_path__ + "img/天津市武清区第二人民医院.609f4311.png";